import ProjectCard from "../PageLayout/ProjectCard";
import Expandable from "./Expandable";
import ProjectHeader from "./ProjectHeader";
import styles from "./Algorithms.module.css";
import sharedStyles from "./shared.module.css";
import { ProjectType } from "../Utils/ProjectType.ts";
import ProjectButton from "../Utils/ProjectButton.jsx";


export default function Algorithms () {




    return (
        <ProjectCard projectName={"Algorithms & Data Structures"} >

            <ProjectHeader title="ALGORITHMS aND DATa STRUCTURES PoRTFoLIO" subTitle="Manchester Metropolitan University" projectType={ProjectType.Code} subTitleInfo="I studied for an MSc in Data Science at Manchester Metropolitan University, achieving a distinction." />

            <p>
                Some of my finest work from the MMU Algorithms and Data Structures unit. I had a lot of fun working on these assessed projects and I managed to get a <strong>95% grade</strong>!
            </p>

            <p>
                Each project explores an Algorithms & Data Structures concept and is implemented with <strong>C#</strong> using <strong>object-oriented</strong> principles. 
            </p>

            <p>
                Some also involved building <strong>Windows Forms</strong> apps which I got the most joy from. I thought it was hilarious making elaborate UIs which probably shouldn’t be possible (or practical), and I definitely got a thrill surprising classmates with them. 
            </p>


            <Expandable title={"Queues"}>
                <div>
                    <p>An implementation of a queue data structure with a windows form app allowing a user to enqueue and dequeue customer objects. I also implemented an algorithm to reverse the order of items in the queue; see demo video
                        for full explanation.
                    </p>
                    <div>
                        <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/3nG53uiMFVQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                    </div>

                    <br />

                    <ProjectButton link={"images/Queue - ReverseK() Algorithm Diagram.png"} name="Diagram from video" />

                </div>
            </Expandable>

            <Expandable title={"Employee Manager (OOP)"} >
                <p>A basic employee managing app which uses a dictionary data structure as well as object-oriented programming principles.</p>
                <div>
                    <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/7xfcQ36Wtjk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>

            </Expandable>

            <Expandable title={"Binary Trees and Recursion"}>

                <p>A binary tree implementation with recursive traversal algorithms. There is also a recursive algorithm that returns the largest value stored in the tree. I also implemented an algorithm to find the first common ancestor
                    between two given nodes. This exercise was particularly challenging and enjoyable. </p>

                    <div>
                        <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/R1x5d70p7cs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>

                    <br />

                    <div className={sharedStyles.links}>
                        <ProjectButton link="images/Ancestor demo.png" name="Diagram from video" />
                        <ProjectButton link="images/preordertraversal.png" name="Preorder traversal diagram" />
                    </div>
            </Expandable>

            <Expandable title={"Airports (Graphs and Reachability)"} >

                <p>Airport managing application which uses a graph data structure to represent an air transport network. It allows users to add and remove airports as well as find reachable airports from a given starting airport.</p>

                <div class="videoWrapper">
                    <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/4XDv53tWlRM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <br />

                <ProjectButton link="images/week6taskBDFS.png" name="Diagram from video" />

            </Expandable>

        </ProjectCard>
    )
}